import React from 'react';
import styled from 'styled-components';
import illustrasiKanggo from '../../../assets/img/illustrasi-kanggo-warning.png';
import Dialog from '../../../components/Dialog';
import { Button } from '../../../components/Styled';

const ImageWrapper = styled.div`
    position: relative;
    display: block;
    height: 140px;
    text-align: center;

    img {
        height: 100%;
    }
`;

interface IDialogCancelPayment {
    onCancelConfim: () => void,
    // eslint-disable-next-line no-unused-vars
    dialogHandler: (showDialog: boolean) => void
}

const DialogCancelPayment: React.FC<IDialogCancelPayment> = (props) => {
    const { onCancelConfim, dialogHandler } = props;

    const onConfirm = () => {
        onCancelConfim();
        dialogHandler(false);
    };

    return (
        <Dialog noWrap>
            <ImageWrapper>
                <img src={illustrasiKanggo} alt="PT. Tenaga Kanggo Indonesia" />
            </ImageWrapper>
            <p className="font-bold text-center my-3">Batalkan Pembayaran?</p>
            <p className="text-center mb-3">Jika kamu batalkan pembayaran ini. seluruh upah yang sudah ditransfer akan dikembalikan</p>
            <div className="row">
                <div className="col-6">
                    <Button block border rounded textBlack primary onClick={() => dialogHandler(false)}>Tidak Jadi</Button>
                </div>
                <div className="col-6">
                    <Button block rounded gradient onClick={() => onConfirm()}>Batalkan</Button>
                </div>
            </div>
        </Dialog>
    );
};

export default DialogCancelPayment;
